import { Controller } from '@hotwired/stimulus';

const BTN_CLASS_ACTIVE = 'btn-active';

export default class extends Controller {
  static values = {
    first: String,
    second: String,
    maxReached: String,
    locale: String,
  };

  static targets = [
    'toggleButton',
    'checkboxContainer',
    'info',
    'firstSelection',
    'secondSelection',
    'firstRemove',
    'secondRemove',
    'startButton',
    'name',
  ];

  connect() {
    this.loadSelection();

    if (this.selected.length) {
      this.toggleButtonTarget.classList.add(BTN_CLASS_ACTIVE);
      this.infoTarget.classList.remove('hidden');
      this.refresh();
    }
  }

  toggle() {
    if (this.isActive()) {
      this.selected = [];
      this.saveSelection();
    }

    this.toggleButtonTarget.classList.toggle(BTN_CLASS_ACTIVE);
    this.infoTarget.classList.toggle('hidden');
    this.toggleCheckboxes();
    this.updateInfo();
  }

  refresh() {
    if (this.isActive()) {
      this.toggleCheckboxes();
      this.updateInfo();

      this.checkboxContainerTargets.forEach((div) => {
        const checkbox = this.getInput(div);
        checkbox.checked = this.selected.some(
          (item) => item.id === checkbox.value,
        );
      });
    }
  }

  toggleCheckboxes() {
    this.checkboxContainerTargets.forEach((div) => {
      div.classList.toggle('hidden');
      this.getInput(div).checked = false;
    });
  }

  select(event) {
    if (this.isActive()) {
      event.preventDefault();

      const row = event.target.closest('a');
      const checkbox = this.getInput(row);
      const name = this.getName(row);

      if (!checkbox.checked && this.selected.length == 2) {
        alert(this.maxReachedValue);
        return;
      }

      checkbox.checked = !checkbox.checked;

      if (checkbox.checked) this.addSelected(checkbox.value, name);
      else this.removeSelected(checkbox.value);

      this.updateInfo();
    }
  }

  addSelected(id, name) {
    this.selected.push({ id, name });

    this.saveSelection();
  }

  removeFirst() {
    this.removeSelected(this.selected[0].id);
    this.updateInfo();
  }

  removeSecond() {
    this.removeSelected(this.selected[1].id);
    this.updateInfo();
  }

  removeSelected(id) {
    this.selected = this.selected.filter((item) => item.id !== id);

    const input = [
      ...this.element.querySelectorAll('input[type="checkbox"]'),
    ].find((input) => input.value === id);
    if (input) input.checked = false;

    this.saveSelection();
  }

  start() {
    window.Turbo.visit(
      `/${this.localeValue}/people/compare/${this.selected[0].id}/${this.selected[1].id}`,
    );
  }

  updateInfo() {
    this.startButtonTarget.disabled = this.selected.length !== 2;

    switch (this.selected.length) {
      case 0:
        this.firstSelectionTarget.classList.remove('hidden');
        this.secondSelectionTarget.classList.add('hidden');
        this.firstSelectionTarget.querySelector('span').innerHTML =
          `<strong>${this.firstValue}</strong>`;
        break;

      case 1:
        this.firstSelectionTarget.classList.remove('hidden');
        this.secondSelectionTarget.classList.remove('hidden');
        this.firstSelectionTarget.querySelector('span').innerHTML =
          '<strong>1:</strong> ' + this.selected[0].name;
        this.secondSelectionTarget.querySelector('span').innerHTML =
          `<strong>${this.secondValue}</strong>`;
        break;

      case 2:
        this.firstSelectionTarget.classList.remove('hidden');
        this.secondSelectionTarget.classList.remove('hidden');
        this.firstSelectionTarget.querySelector('span').innerHTML =
          '<strong>1:</strong> ' + this.selected[0].name;
        this.secondSelectionTarget.querySelector('span').innerHTML =
          '<strong>2:</strong> ' + this.selected[1].name;
        break;
    }

    this.firstRemoveTarget.classList.toggle(
      'hidden',
      this.selected.length == 0,
    );
    this.secondRemoveTarget.classList.toggle(
      'hidden',
      this.selected.length !== 2,
    );
  }

  isActive() {
    return this.toggleButtonTarget.classList.contains(BTN_CLASS_ACTIVE);
  }

  getInput(div) {
    return div.querySelector('input[type="checkbox"]');
  }

  getName(div) {
    return div.querySelector('.js-name').innerText;
  }

  saveSelection() {
    localStorage.setItem('compare', JSON.stringify(this.selected));
  }

  loadSelection() {
    this.selected = JSON.parse(localStorage.getItem('compare')) || [];
  }
}
